<template>
  <div class="buttontab-bd">
    <div class="ub">
      <div v-for="item in list" class="ub-f1" :class="[{'cur': item === value},{'radius': type === 'radius'}]" @click="onEmit(item)">{{item}}
      </div>
    </div>
  </div>
</template>
<script>
/**
   * @param list [Array] tab栏目数组，字符串数组
   * @param type [String] tab栏目显示类型，radius[圆角],default[默认]
   * @param value [String] tab选中值用v-model进行绑定
   * @param change [Function] 切换类目触发事件
   * @describe
   *
   * @example
   *
    <t-buttontab :list="['文章', '商品','详情']" v-model="" @change=""></t-buttontab>
   */

export default {
  name: 'tButtontab',
  props: {
    list: {
      type: Array,
      default: [],
    },
    type: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted: function () {},
  methods: {
    onEmit(item) {
      this.$emit('input', item);
      this.$emit('change', item);
    },
  },
};

</script>
<style lang="scss">
@import "../style/mixin";

.buttontab-bd {
  .ub .ub-f1 {
    position: relative;
    color: #ccc;
    line-height: 32px;
    height: 32px;
    text-align: center;
    font-size: 14px;
    &.cur {
      color: #fff;
      background: #f4b357;
    }
    &:after {
      box-sizing: border-box;
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      width: 200%;
      border-right: 1px solid #ccc;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      border-left: none;
      color: #ccc;
      height: 200%;
      transform-origin: left top;
      transform: scale(0.5);
      z-index: 1;
    }
    &:first-child {
      @include border-1px(#ccc);
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      &:after {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
    }
    &:last-child {
      @include border-1px(#ccc);
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      &:after {
        border-left: none;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
    &.radius:first-child {
      @include border-1px(#ccc);
      border-top-left-radius: 16px;
      border-bottom-left-radius: 16px;
      &:after {
        border-top-left-radius: 32px;
        border-bottom-left-radius: 32px;
      }
    }
    &.radius:last-child {
      @include border-1px(#ccc);
      border-top-right-radius: 16px;
      border-bottom-right-radius: 16px;
      &:after {
        border-left: none;
        border-top-right-radius: 32px;
        border-bottom-right-radius: 32px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/buttontab.vue